module.exports = __webpack_public_path__ + "img/img_top_technology_retail@3x.8a48652c.png";